import { call, put } from 'redux-saga/effects';

import { Set } from '~commonInfra/utils/Set';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';
import { DeleteExtractTasksAction } from '../../../extractTask/services/DeleteExtractTasksAction';
import { DeleteExtractRefreshAction } from '../../actions/extractRefresh/DeleteExtractRefreshAction';

export function* handleDeleteExtractRefreshAction(action: DeleteExtractRefreshAction) {
  try {
    yield call(executeDeleteExtractRefreshAction, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeDeleteExtractRefreshAction(items: IExtractTaskInfo[]) {
  return DeleteExtractTasksAction.executeWithContext(Set.fromIdItemArray(items));
}
